module.exports = __webpack_public_path__ + "media/images/flags/AD-d2866f58c8d98485147fcc0deb5b4fcf.svg";